// extracted by mini-css-extract-plugin
export default {"container":"video_container__uSY83","content":"video_content__i1RcO","text":"video_text__lvxGg","video":"video_video__PNEUP"};